import React, { memo, useState, useEffect } from 'react';
import styles from './ListSimcards.module.scss';
import ListContainer from '../../../../../shared/components/ListContainer';
import SVG from 'react-inlinesvg';
import LoadingDots from './LoadingDots';
import { toast } from '../../../../../shared/helpers/toast';
import { useHistory } from 'react-router-dom';
import { launchSVG } from '../../../../../shared/helpers/icons';
import Tooltip from '@material-ui/core/Tooltip';

const ListSimcards = ({
  simCards,
  fetching,
  totalItems,
  fetchingMoreItems,
  onScrollBottomAction,
  setSimcardSelected,
  enableCheckboxes = false,
  selectedRows = [],
  onSelectRow = () => {},
  getGpsDevicesRequest, 
  gps,                 
}) => {
  const history = useHistory();
  const [pendingIccid, setPendingIccid] = useState(null);

  const handleGotoGps = (iccid, e) => {
    e.stopPropagation();
    setPendingIccid(iccid);
    
    if (getGpsDevicesRequest) {
      getGpsDevicesRequest({ search: iccid });
      
    } else {
      
      toast('No se puede buscar el GPS asociado', 'gps-function-error');
      setPendingIccid(null);
    }
  };

  useEffect(() => {
    if (
      pendingIccid &&
      gps &&
      Array.isArray(gps.gps_devices)
    ) {
      if (gps.gps_devices.length === 0) {
        toast('Intente nuevamente', 'gps-not-found');
        setPendingIccid(null);
        return;
      }
      const gpsFound = gps.gps_devices.find(
        g => g.simcard && g.simcard.iccid === pendingIccid
      );
      if (gpsFound && gpsFound.name) {
        history.push(`/stock/gps/${gpsFound.name}`);
        setPendingIccid(null);
      }
    }
  }, [gps, pendingIccid, history]);

  const handleSimcardClick = (simcard) => {
    setSimcardSelected(simcard);
    history.push(`/stock/simcard/${encodeURIComponent(simcard.iccid)}`);
  };
  const changeFormatDate = (fechaISO) => {
    const fecha = new Date(fechaISO);
    
    const dia = String(fecha.getUTCDate()).padStart(2, '0');
    const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0'); 
    const anio = fecha.getUTCFullYear();

    return `${dia}-${mes}-${anio}`;
}

  return (
    <ListContainer
      skeletonColumn={6}
      loading={fetching}
      totalItems={totalItems}
      fetchingMoreItems={fetchingMoreItems}
      onScrollBottomAction={onScrollBottomAction}
    >
      {simCards.map(simCard => (
        <div
          key={simCard._id}
          className={styles.row}
          onClick={() => handleSimcardClick(simCard)}
        >
          {enableCheckboxes && (
            <div className={styles.checkboxCell} onClick={(e) => e.stopPropagation()}>
              <input
                type="checkbox"
                checked={selectedRows.includes(simCard._id)}
                onChange={e => onSelectRow(simCard._id, e.target.checked)}
                onClick={e => e.stopPropagation()}
              />
            </div>
          )}
          <div> {changeFormatDate(simCard.created)} </div>
          <div> {simCard.iccid} </div>
          <div> {simCard.number} </div>
          <div> {simCard.operator} </div>
          <div className={styles.statusCell}>
            <span
              className={`
                ${styles.status}
                ${styles[simCard.status_name?.toLowerCase()?.replace(/\s+/g, '-')] || ''}
              `}
            >
              {simCard.status_name || '-'}
            </span>
            {simCard.status_name !== 'Baja' && simCard.substatus?.value?.toLowerCase() !== 'no asignado' && (
              <span className={styles.arrow}>›</span>
            )}
          </div>
          <div
  className={`${styles.subStatus} ${
    simCard.status_name?.toLowerCase() !== 'baja' &&
    simCard.substatus?.value &&
    simCard.substatus?.value.trim() !== '-' &&
    simCard.substatus?.value.toLowerCase().trim() !== 'no asignado'
      ? styles[simCard.status_name?.toLowerCase()?.replace(/\s+/g, '-')] || ''
      : ''
  }`}
>
  {
    simCard.substatus?.value &&
    simCard.substatus?.value.trim().toLowerCase() !== 'no asignado'
      ? simCard.substatus?.value
      : '-'
  }
</div>



          <div className={styles.textAlignCenter}>
            <SVG
              src={simCard.enabledIcon}
              className={`${styles.svg} ${
                simCard.enabled ? styles.enabled : styles.disabled
              }`}
            />
          </div>
          <div className={styles.iconColumn}>
            {["Asignado a GPS", "Asginado a GPS"].includes(simCard.status_name) ? (
              <Tooltip title="Ver GPS asignado" placement="bottom">
                <div
                  onClick={e => handleGotoGps(simCard.iccid, e)}
                  className={styles.launchIconWrapper}
                >
                  {pendingIccid === simCard.iccid ? (
                    <LoadingDots />
                  ) : (
                    <SVG src={launchSVG} className={styles.launchIcon} />
                  )}
                </div>
              </Tooltip>
            ) : (
              <div />
            )}
          </div>
        </div>
      ))}
    </ListContainer>
  );
};

export default memo(ListSimcards);
